var fieldset = {
  "minWidth": "0",
  "padding": "0",
  "margin": "0",
  "border": "0"
};

export { fieldset };
